<script lang="ts">
  import ALL_OBJECTS from "./objects";

  let width = 800;
  let height = 600;
  let name = "Level Name";
  let viewLevelJSON = false;
  let mouse = { x: 0, y: 0 };
  let mouseDownAt: number | null;
  let instances = [];

  let selectedObjectIndex: number | null = null;

  $: objects = [
    {
      key: "mermaid",
      center: { x: 200, y: 100 },
      rotate: 15,
      layer: 2,
      scale: 0.75,
    },
    {
      key: "key",
      center: { x: 500, y: 200 },
      rotate: -45,
      layer: 1,
      scale: 1.5,
    },
    {
      key: "anchor",
      center: { x: 300, y: 400 },
      rotate: 0,
      layer: 3,
      scale: 1,
    },
  ];
  $: selectedObject = objects[selectedObjectIndex] || null;
  $: level = { name, height, width, objects };
  $: output = JSON.stringify(level, null, 2);
  $: dataUrl = "data:text/json;charset=utf-8," + encodeURIComponent(output);

  function handleMouseMove(event) {
    if (typeof selectedObjectIndex !== "number") return;

    // Store the previous position temporarily so we can calculate
    // the move distance
    const prev = { x: mouse.x || 0, y: mouse.y || 0 };

    // Update the current mouse position
    mouse = { x: event.clientX, y: event.clientY };

    const diff = { x: mouse.x - prev.x, y: mouse.y - prev.y };

    if (!mouseDownAt) return;

    const obj = objects[selectedObjectIndex];
    const x = diff.x + obj.center.x;
    const y = diff.y + obj.center.y;
    objects[selectedObjectIndex] = { ...obj, center: { x, y } };
  }

  function handleWindowMouseDown() {
    mouseDownAt = Date.now();
  }

  function handleClick(event, index) {
    // Capture event bubbling so parent handlers don't see this
    // click event.
    event.preventDefault();
    event.stopPropagation();

    const elapsed = Date.now() - mouseDownAt;

    mouseDownAt = null;

    // If more than 200ms, then the user may be trying to drag,
    // so don't treat it like a click.
    if (elapsed > 200) return;

    // const obj = objects[index];
    selectedObjectIndex = index;
  }

  function handleClickContainer(event) {
    selectedObjectIndex = null;
  }

  function handleHoverNav() {
    mouseDownAt = null;
  }
</script>

<svelte:window on:mousedown={handleWindowMouseDown} />

<main>
  <section on:click={handleClickContainer} on:mousemove={handleMouseMove}>
    {#each level.objects as object, i}
      <div
        on:click={(e) => handleClick(e, i)}
        class:selected={selectedObjectIndex === i}
      >
        <svelte:component
          this={ALL_OBJECTS[object.key]}
          center={object.center}
          rotate={object.rotate}
          layer={object.layer}
          scale={object.scale}
          selected={selectedObjectIndex === i}
          bind:this={instances[i]}
        />
      </div>
    {/each}
  </section>
  <nav on:mouseover={handleHoverNav}>
    <fieldset>
      <label for="width">Level Name</label>
      <input bind:value={name} />
    </fieldset>
    <fieldset>
      <label for="width">Size</label>
      <input
        bind:value={width}
        type="number"
        min="400"
        max="3000"
        step="10"
        id="width"
      />
      <input bind:value={height} type="number" min="400" max="3000" step="10" />
    </fieldset>

    {#if selectedObject}
      <fieldset>
        <label for="object-type">Object</label>
        <select bind:value={selectedObject.key} id="object-type">
          {#each Object.keys(ALL_OBJECTS) as key}
            <option value={key}>{key}</option>
          {/each}
        </select>
      </fieldset>
      <fieldset>
        <label for="object-scale">Scale</label>
        <input
          bind:value={selectedObject.scale}
          type="number"
          step="0.1"
          min="0.1"
          max="10"
        />
      </fieldset>
      <fieldset>
        <label for="object-scale">Rotation</label>
        <input
          bind:value={selectedObject.rotate}
          type="number"
          step="5"
          min="-360"
          max="360"
        />
      </fieldset>
    {/if}

    <p>
      <a class="button" download={name + ".json"} href={dataUrl}>Download</a>
    </p>

    {#if viewLevelJSON}
      <p>
        <a href="#" on:click|preventDefault={() => (viewLevelJSON = false)}
          >Hide</a
        >
      </p>
      <pre>{output}</pre>
    {:else}
      <a href="#" on:click|preventDefault={() => (viewLevelJSON = true)}
        >View level JSON</a
      >
    {/if}
  </nav>
</main>

<style>
  main {
    display: flex;
    height: 100%;
  }
  section {
    flex: 1;
    align-items: center;
    display: flex;
    justify-content: center;
    position: relative;
  }
  /* canvas {
    border: 1px solid #ccc;
  } */

  nav {
    background: #ececec;
    overflow: auto;
    padding: 2rem;
    width: 16rem;
  }
  fieldset {
    border: 0 none;
    margin: 0 0 1.25rem 0;
    padding: 0;
  }
  label {
    display: block;
    font-weight: bold;
    margin: 0 0 1.25rem 0;
  }
  input {
    padding: 0.75rem 1rem;
    border-radius: 0.3rem;
  }

  pre {
    display: block;
    margin: 1.25rem 0;
    overflow: auto;
    max-height: 40rem;
  }

  a {
    color: darkcyan;
  }

  .button {
    background: darkcyan;
    border-radius: 2rem;
    color: white;
    display: block;
    text-align: center;
    transition: background-color 0.2s ease;
    padding: 0.75rem 1.25rem;
  }
  .button:hover {
    background: goldenrod;
    text-decoration: none;
  }

  .text-gray-500 {
    color: #999;
  }

  .selected {
    background: red;
  }
</style>
